import { useIsSnapshot } from "store/hooks/submissionHooks";

const HiddenIfSnapshot = ({ children }) => {
  const isSnapshot = useIsSnapshot();
  return isSnapshot ? <></> : children;
};

export default HiddenIfSnapshot;
